import { render, staticRenderFns } from "./ResearchGroupsVerticalCard.html?vue&type=template&id=7c1d63ca&scoped=true&"
import script from "./ResearchGroupsVerticalCard.vue?vue&type=script&lang=js&"
export * from "./ResearchGroupsVerticalCard.vue?vue&type=script&lang=js&"
import style0 from "./ResearchGroupsVerticalCard.scss?vue&type=style&index=0&id=7c1d63ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d63ca",
  null
  
)

export default component.exports